module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ContentHeader":{"alt":"Obrázek kategorie {category}"}},"de":{"ContentHeader":{"alt":"Kategoriebild {category}"}},"sk":{"ContentHeader":{"alt":"Obrázok kategórie {category}"}}}')
  delete Component.options._Ctor
}
